import React, { ReactNode } from 'react';
import './index.scss';
import { BottomNavigation, BottomNavigationAction, Box } from '@mui/material';
import EventIcon from '@mui/icons-material/Event';
import PersonIcon from '@mui/icons-material/Person';
import PaymentIcon from '@mui/icons-material/Payment';
import SportsKabaddiIcon from '@mui/icons-material/SportsKabaddi';
import { useLocation, useNavigate } from 'react-router-dom';
import { useMediaQuery, useTheme } from '@mui/material';
import InstructorDesktopLayout from '../InstructorDesktopLayout';
import { CurrentUserProvider, useCurrentUser } from '../../hooks/useCurrentUser';

export default function Index({ children }: { children: ReactNode }) {
  return (
    <CurrentUserProvider>
      <TabRouterContent>{children}</TabRouterContent>
    </CurrentUserProvider>
  );
}

function TabRouterContent({ children }: { children: ReactNode }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { isInstructor, isLoadingCurrentUser } = useCurrentUser();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));

  const onClickTab = (tab: string) => {
    navigate(tab);
  };

  if (isLoadingCurrentUser) {
    return null;
  }

  if (isInstructor && isDesktop) {
    return <InstructorDesktopLayout>{children}</InstructorDesktopLayout>;
  }

  return (
    <Box maxWidth={300} mx="auto" my={2}>
      {children}
      <Box className="tabs-container">
        <BottomNavigation
          sx={{ backgroundColor: 'primary.main' }}
          showLabels
          value={location.pathname}
          onChange={(_, newValue) => onClickTab(newValue)}
        >
          <BottomNavigationAction
            sx={{ color: 'gray' }}
            label="Reservas"
            icon={<EventIcon style={{ color: 'gray' }} />}
            value="/home"
          />
          <BottomNavigationAction
            sx={{ color: 'gray' }}
            label="Perfil"
            icon={<PersonIcon style={{ color: 'gray' }} />}
            value="/profile"
          />
          {!isInstructor && (
            <BottomNavigationAction
              sx={{ color: 'gray' }}
              label="Pago"
              icon={<PaymentIcon style={{ color: 'gray' }} />}
              value="/payment"
            />
          )}
          {isInstructor && (
            <BottomNavigationAction
              sx={{ color: 'gray' }}
              label="Estudiantes"
              icon={<SportsKabaddiIcon style={{ color: 'gray' }} />}
              value="/students"
            />
          )}
        </BottomNavigation>
      </Box>
    </Box>
  );
}
